import { Box, FormControl, FormLabel, Stack, Textarea } from '@chakra-ui/react';
import { Input } from 'components/v4';
import {
    formInputStyles,
    formLabelStyling,
    stackSpacing,
    stackStyling,
} from 'components/forms/new/formStyles';

const readOnlyStyle = (darkMode) => ({
    backgroundColor: darkMode ? '#1E2021' : '#F7FAFC',
    color: darkMode ? '#A0AEC0' : '#4A5568',
});

const ReadOnlyProfileField = ({
    label,
    value,
    darkMode,
    isTextarea = false,
}) => (
    <FormControl sx={{ margin: '0 !important' }}>
        <Stack
            direction="row"
            spacing={stackSpacing}
            sx={{ ...stackStyling(), ...formInputStyles }}>
            <Box>
                <FormLabel sx={formLabelStyling(darkMode)}>{label}</FormLabel>
            </Box>
            <Box flex="1" paddingTop="15px" minWidth="450px">
                {isTextarea ? (
                    <Textarea
                        value={value || ''}
                        isDisabled
                        rows={3}
                        resize="none"
                        style={readOnlyStyle(darkMode)}
                    />
                ) : (
                    <Input
                        value={value || ''}
                        isDisabled
                        className="!h-[30px] rounded-[5px] pl-2"
                        style={readOnlyStyle(darkMode)}
                    />
                )}
            </Box>
        </Stack>
    </FormControl>
);

export default ReadOnlyProfileField;
